import * as React from 'react';
import * as style from './style.scss';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { Text, Heading, TextButton } from 'wix-style-react';
import { InjectedBiLoggerProps, provideLogger } from '../../../../../services/bi-logger/logger-provider';
import * as classnames from 'classnames';
import { MOBILE_SECTION, MOBILE_SECTION_LINK } from '../../../../../consts/data-hooks';

class MobileSectionComponent extends React.PureComponent<InjectedTranslateProps & InjectedBiLoggerProps> {

  private reportClicked() {
    this.props.logger.reportInstallOneappLinkClicked();
  }

  render() {
    const { t } = this.props;
    return <section data-hook={MOBILE_SECTION}
                    className={classnames(style['settings-section'])}>
            <span className={style.content}>
              <div className={style['settings-channel-header']}>
                <div>
                  <Heading appearance="H3">{t('mobile.title')}</Heading>
                  <Text size="medium" weight="thin" secondary>
                    {t('mobile.description')}
                    <TextButton
                      dataHook={MOBILE_SECTION_LINK}
                      as="a"
                      href="https://apps.wix.com/mobile/v1/mobile-redirect/wix-one-app?referralAdditionalInfo=NOTIFICATIONS_SETTINGS"
                      onClick={() => this.reportClicked()}
                      target="_blank"
                    >
                      {t('mobile.download')}
                    </TextButton>
                  </Text>
                </div>
              </div>
            </span>
    </section>;
  }
}

export const MobileSection = provideLogger<{}>(translate(undefined, { wait: true })(MobileSectionComponent));
